import { useAuth } from "../../contexts/AuthContext";
import styles from "../../styles/components/SettingsSidebar.module.css";

const SettingsSidebar = ({ items = [], activeSection, onSelect }) => {
  const { logout } = useAuth();

  return (
    <aside className={styles.sidebar}>
      <div className={styles.sidebarInner}>
        <div className={styles.menuList}>
          {items.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`${styles.menuItem} ${
                activeSection === item.id ? styles.menuItemActive : ""
              }`}
              onClick={() => onSelect(item.id)}
            >
              {item.label}
            </button>
          ))}
        </div>

        <button
          type="button"
          className={styles.logoutButton}
          onClick={logout}
        >
          Cerrar sesión
        </button>
      </div>
    </aside>
  );
};

export default SettingsSidebar;
